<template>
  <v-card outlined>
    <v-card-title>
      Sales by Room
    </v-card-title>
    <v-divider class='mx-4'/>
    <v-card-text>
      <im-doughnut-chart :chart-data='chart_data' :options='chart_options' :height='250'/>
    </v-card-text>
  </v-card>
</template>

<script>

  export default {

    components: {
      'im-doughnut-chart': () => import('@/components/Statistics/DoughnutChart')
    },

    props: {
      sales: Object,
      rooms: Array
    },

    computed: {

      chart_data() {
        return {
          labels: this.getChartLabels(),
          datasets: [
            {
              data: this.getChartData(),
              outlineColor: ['#0080ff', '#00ff80', '#ff8000', '#FF9800', '#8000ff'],
              backgroundColor: ['#0080ff', '#00ff80', '#ff8000', '#FF9800', '#8000ff'],
            }
          ]
        }
      },

      chart_options() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          fill: false,
          tooltips: {
            mode: 'index'
          },
          legend: false
        }
      }

    },

    methods: {
      getChartLabels() {
        let labels = [];
        if (!this.sales.datasets.rooms)
          return labels;

        for (let room in this.sales.datasets.rooms) {
          if (Object.prototype.hasOwnProperty.call(this.sales.datasets.rooms, room))
            labels.push(this.rooms[room].text);
        }

        return labels;
      },

      getChartData() {
        let data = [];
        if (!this.sales.datasets.rooms)
          return data;

        for (let room in this.sales.datasets.rooms) {
          if (Object.prototype.hasOwnProperty.call(this.sales.datasets.rooms, room))
            data.push(_.sum(this.sales.datasets.rooms[room].sales));
        }

        return data;
      }
    }

  }
</script>